import {Button, Modal} from "react-bootstrap";

interface ConfirmationModalProps {
    show: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    confirmText: string;
    cancelText: string;
    loading: boolean;
    confirmVariant?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    show,
    onClose,
    onConfirm,
    title,
    message,
    confirmText,
    cancelText,
    loading,
    confirmVariant = "primary"
}) => {
    return (
        <Modal show={show} onHide={onClose} centered className="custom-modal confirmation-modal">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{message}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose} disabled={loading}>
                    {cancelText}
                </Button>
                <Button variant={confirmVariant} onClick={onConfirm} disabled={loading}>
                    {loading ? <i className="fa-solid fa-spinner fa-spin me-1"></i> : null}
                    {confirmText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmationModal;
